import { IsTile } from "core/tiles";
export function IsTileWithMesh(b) {
    if (b === null || typeof b !== "object")
        return false;
    const obj = b;
    return obj.surface !== undefined && IsTile(b);
}
//# sourceMappingURL=map.interfaces.js.map